module.exports = __webpack_public_path__ + "img/trash.023ea725.svg";